import checkout from "./form";

const {
  formField: {
    accountOwner,
    bankAccountNumber,
    bankName,
    certificateNumber,
    chiefAccountant,
    documentNumber,
    signer,
    taxAgentCode,
    taxAgentName,
    taxCode,
    taxPayers,
    timeSign,
    whyRefund,
    sendTo,
    attachDocument,
  },
} = checkout;

const initialValues = {
  [accountOwner.name]: "",
  [attachDocument.name]: "",
  [bankAccountNumber.name]: "",
  [bankName.name]: "",
  [certificateNumber.name]: "",
  [chiefAccountant.name]: "",
  [documentNumber.name]: "",
  [taxAgentCode.name]: "",
  [signer.name]: "",
  [taxAgentName.name]: "",
  [taxCode.name]: "",
  [taxPayers.name]: "",
  [whyRefund.name]: "",
  [timeSign.name]: "",
  [sendTo.name]: "",
};

export default initialValues;
